import React, { useEffect, useState } from 'react';
import throttle from 'lodash/throttle';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { GridWrapper } from '@yme/atoms/grid';
import { useMenuHeight, useHeaderHeight } from '@yme/common/hooks';
import { getIsKioskVersion, getIsNavDarkModeEnabled, getPageLevelNavigationData, getRTL, } from '@yme/selectors/common';
import { setPageLevelNavigationStickyMenuShown } from '../redux/actions';
import { getIsMenuOpen, getPageLevelNavigationStickyMenuShown } from '../redux/selectors';
import { PageLevelNavigation } from './PageLevelNavigation';
import { CONTAINER_PROPS, DESTINATION_CONTAINER_PROPS, SCROLL_VALUE_FOR_MENU_VISIBILITY, } from './constants';
import { FloatingContainerStyled } from './styled';
import { usePageNavigationData } from './usePageNavigationData';
export function PageLevelNavigationContainer() {
    const [startScrollPosition, setStartScrollPosition] = useState(null);
    const [prevScrollPosition, setPrevScrollPosition] = useState(0);
    const isRightToLeft = useSelector(getRTL);
    const isPageLevelNavigationStickyMenuShown = useSelector(getPageLevelNavigationStickyMenuShown);
    const pageLevelNavigationData = useSelector(getPageLevelNavigationData);
    const isMenuOpen = useSelector(getIsMenuOpen);
    const isNavDarkModeEnabled = useSelector(getIsNavDarkModeEnabled);
    const isKioskVersion = useSelector(getIsKioskVersion);
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const headerMenuHeight = useMenuHeight();
    const headerHeight = useHeaderHeight();
    // reset scroll when route has been changed
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    const handleScroll = throttle(() => {
        const currentScrollPosition = window.scrollY;
        const isScrolledUp = currentScrollPosition < prevScrollPosition;
        if (startScrollPosition === null && currentScrollPosition > 0) {
            setStartScrollPosition(currentScrollPosition);
        }
        if ((!isScrolledUp || currentScrollPosition < headerMenuHeight) &&
            startScrollPosition !== null) {
            setStartScrollPosition(null);
        }
        const scrolledUpForVisibility = isScrolledUp &&
            startScrollPosition !== null &&
            startScrollPosition - currentScrollPosition > SCROLL_VALUE_FOR_MENU_VISIBILITY;
        const shouldBeVisible = pageLevelNavigationData?.isDestinationPage
            ? currentScrollPosition > headerMenuHeight
            : scrolledUpForVisibility && currentScrollPosition > headerMenuHeight;
        setPrevScrollPosition(currentScrollPosition);
        if (isPageLevelNavigationStickyMenuShown !== shouldBeVisible) {
            dispatch(setPageLevelNavigationStickyMenuShown(shouldBeVisible));
        }
    }, 100);
    const { data, isUnitPDP, isEDP, navigationData, isClothingOrAccessoriesPDP } = usePageNavigationData({
        handleScroll,
    });
    if (!data) {
        return null;
    }
    const { title, dealerPageItem, dealerCategoryId, upButton, sectionView, isDestinationPage, isSectionViewEnabled, } = data;
    const isDealerLocatorLinkExists = !isDestinationPage && Boolean(dealerPageItem);
    if (isKioskVersion) {
        return null;
    }
    return (React.createElement(FloatingContainerStyled, { isVisible: isPageLevelNavigationStickyMenuShown ||
            Boolean(pageLevelNavigationData?.isDestinationDetailsPage), isDealerLocatorLinkExists: isDealerLocatorLinkExists, isDestinationPage: isDestinationPage, isEDP: isEDP, isMenuOpen: isMenuOpen, isNavDarkModeEnabled: isNavDarkModeEnabled, isClothingOrAccessoriesPDP: isClothingOrAccessoriesPDP, headerHeight: headerHeight, className: "page-level-nav" },
        React.createElement(GridWrapper, { containerProps: isDestinationPage ? DESTINATION_CONTAINER_PROPS : CONTAINER_PROPS },
            React.createElement(PageLevelNavigation, { title: title, dealerPageItem: dealerPageItem, pageLevelNavigationItems: navigationData, dealerCategoryId: dealerCategoryId, isUnitPDP: isUnitPDP, isRightToLeft: isRightToLeft, upButton: upButton, sectionView: sectionView, isDestinationPage: isDestinationPage, isClothingOrAccessoriesPDP: isClothingOrAccessoriesPDP, isSectionViewEnabled: isSectionViewEnabled }))));
}
